import React from 'react';
import '../../App.css'
import {Flex, Spacer, Image, Box} from "@chakra-ui/react";
import {InnerItem} from "../../data/InnerItem";
import {useTranslation} from "react-i18next";

interface InnerItemComponentProps {
    itemData: InnerItem
}

const InnerItemComponent: React.VFC<InnerItemComponentProps> = (props) => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex alignItems="start"
              flexDirection="row"
              maxWidth="500px"
              paddingBottom="12px"
              paddingTop="12px">
            <Image
                marginRight="20px"
                marginTop="10px"
                maxWidth="40px"
                maxHeight="40px"
                src={props.itemData?.image}
                alt={props.itemData?.title}
                objectFit="contain"
            />

            <Flex flexDirection="column" marginRight="8" maxWidth="680px" textAlign="start"   paddingTop="8px">
                <Box marginBottom="10px">
                    <span className="body-content-small">{t(props.itemData?.title)}</span>
                </Box>
                <span className="body-content-small-gray">
                   {t(props.itemData?.content)}
                </span>
            </Flex>
            <Spacer/>
        </Flex>
    )

}
export default InnerItemComponent